import ReactDOM from 'react-dom'

import App from '../application/MainApplication'

const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then(function () {
        console.log('Service worker registration successful')
      })
      .catch(function (err) {
        console.log('Service worker registration failed: ', err)
      })
  }
}

// register service worker
registerServiceWorker()

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<App />, document.querySelector('#main'))
})

if (module.hot) {
  module.hot.accept('../application/MainApplication', () => {
    ReactDOM.render(<App />, document.querySelector('#main'))
  })
}
